<div *ngIf="shouldShowPreloader" class="preloader-backdrop" aria-hidden="true">
  <div class="loader" aria-hidden="true"></div>
</div>
